<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.typeNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.typeName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="typeNumber" label="编码" width="140" />
      <el-table-column prop="typeName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="description" label="说明" min-width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.typeId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.typeId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.typeId ? '修改工位类型' : '新增工位类型'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="编码" prop="typeNumber">
          <el-input v-model="form.typeNumber" />
        </el-form-item>
        <el-form-item label="名称" prop="typeName">
          <el-input v-model="form.typeName" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.description" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listWorkstationType, getWorkstationType, saveWorkstationType, updateWorkstationType, deleteWorkstationType
} from '../../api/workstationType'

function emptyForm() {
  return {
    typeId: '',
    typeNumber: '',
    typeName: '',
    description: '',
    active: '1'
  }
}

export default {
  name: 'MesWorkstationTypePage',
  components: { ListPagination },
  data() {
    return {
      query: { typeNumber: '', typeName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        typeNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        typeName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listWorkstationType({
        currentPage: this.page,
        pageSize: this.pageSize,
        typeNumber: this.query.typeNumber,
        typeName: this.query.typeName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getWorkstationType(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form)
        const req = payload.typeId ? updateWorkstationType(payload) : saveWorkstationType(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.typeId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteWorkstationType(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
